// extracted by mini-css-extract-plugin
export default {"tick":"tick_tick__Qr6d4"};